// extracted by mini-css-extract-plugin
export default {"success":"MessageSuccess_success__sohIX","button_close":"MessageSuccess_button_close__9DFO9"};